import Container from "@mui/material/Container";
import { TextField, Box } from "@mui/material";
import ColorSelection from "./colorSelection";
import useUnassigned from "../services/unassignedService";
import EventContext from "../store/event-context";
import { useEffect, useState, useContext } from "react";
import MaterialTable from '@material-table/core';
import ActionButton from './actionButton';
import Alert from '@mui/material/Alert';
import { CircularProgress} from '@mui/material';

const Unassigned = () => {
  const {
    unassignedData,
    isLoadingUnassigned,
    unassignedServerError,
    getUnassigned,
    removeUnassigned,
    addUnassigned,
  } = useUnassigned(); 
  const eventctx = useContext(EventContext);
  const [showAlert, setShowAlert] = useState(true);
  const [rangeTerm, setRangeTerm] = useState("");
  const [deleteItem, setDeleteItem] = useState("");
  const [color, setColor] = useState(eventctx.event.colors[0]);

  const deleteCapnr = () => {
    //console.log("Deleting Capnr");
    //console.log(deleteItem);
    removeUnassigned(color, deleteItem);
  };

  const addCapnr = () => {
    //console.log("Adding Capnr");
    //console.log(rangeTerm);
    addUnassigned(color, rangeTerm);
  };

  const handleChange = (event) => {
    setRangeTerm(event.target.value);
  };

  const handleChange2 = (event) => {
    setDeleteItem(event.target.value);
  };

  useEffect(() => {
    //console.log("Updating with color" + color);
    getUnassigned(color);
    // Adding getUnassinged would trigger infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color, setColor]);

  useEffect(() => {
    //console.log("Resetting setShowAlert");
    setShowAlert(true);
    setDeleteItem("");
    setRangeTerm("");
  }, [isLoadingUnassigned, setShowAlert]);

  return (
    <div>

      <Container id='ColorSelectionContainer' sx={{mt: '14px'}}>
        <ColorSelection color={color} setColor={setColor} fieldWidth='200'/>
      </Container>
      <Container id='RangeInputAndButton' sx={{mt:'10px'}}>
        <TextField
          id="Input-Range"
          label="Range (van-tot)"
          type="text"
          value={rangeTerm}
          onChange={handleChange}
          sx={{ width: '200px', backgroundColor: 'common.white', marginRight: '10px'}}
        />
        <ActionButton  
          id="AddButton" 
          size="medium" 
          color="primary" 
          onClick={addCapnr}
          sx={{width: '180px', mt: '4px'}}>
          Toevoegen
        </ActionButton>
      </Container>
      <Container id='DeleteInputAndButton' sx={{mt:'10px'}}>
        <TextField
          id="Input-Delete"
          label="Capnummer"
          type="number"
          value={deleteItem}
          onChange={handleChange2}
          sx={{ width: '200px', backgroundColor: 'common.white', marginRight: '10px'}}
        />
        <ActionButton  
          id="DeleteButton" 
          size="medium" 
          color="secondary" 
          onClick={deleteCapnr}
          sx={{width: '180px', mt: '4px'}}>
          Verwijder
        </ActionButton>
      </Container>
      <Box sx={{width: '180px', mt: '14px', ml: '26px'}}>
      <MaterialTable
        //icons={tableIcons}
        localization={{
          pagination: {
            labelDisplayedRows: '{from}-{to} van {count}',
            labelRowsSelect: 'Rijen',
            labelRowsPerPage: 'Rijen per pagina:',
            firstAriaLabel: 'Eerste pagina',
            firstTooltip: 'Eerste pagina',
            previousAriaLabel: 'Vorige pagina',
            previousTooltip: 'Vorige pagina',
            nextAriaLabel: 'Volgende pagina',
            nextTooltip: 'Volgende pagina',
            lastAriaLabel: 'Laatste pagina',
            lastTooltip: 'Laatste pagina'
          },
          toolbar: {
            addRemoveColumns: 'Verwijder of voeg kolommen toe',
            nRowsSelected: '{0} rij(en) geselecteerd',
            showColumnsTitle: 'Toon kolommen',
            showColumnsAriaLabel: 'Toon kolommen',
            exportTitle: 'Export',
            exportAriaLabel: 'Export',
            exportName: 'Export als CSV',
            searchTooltip: 'Zoeken',
            searchPlaceholder: 'Zoeken'
            },
          header: {
              actions: 'Acties'
          },
          body: {
              emptyDataSourceMessage: 'Er zijn geen resultaten',
              filterRow: {
                  filterTooltip: 'Filter'
              }
          }
        }}
        options={{
          showTitle: false,
          toolbar: false,
          paging: false,
          headerStyle: { position: 'sticky', top: 0, fontWeight: 'bold', color: "white", backgroundColor: '#019ce2' },
          rowStyle: (rowData) => ({
            backgroundColor:
                rowData.tableData.id % 2 === 0 ? "#D2EAEE" : "#E9F4F6"
          }),
          padding: 'dense'
        }}
        columns={[
          {
            title: "ID",
            field: "id",
            hidden: true,
            width: 0
          },
          {
            title: "Beschikbare caps",
            field: "capnr",
          }
        ]}
        data={unassignedData}
      />
      </Box>

      {unassignedServerError && showAlert && (
        <Alert
          onClose={() => {
            setShowAlert(false);
          }}
          severity="error"
        >
          {unassignedServerError}
        </Alert>
      )}
      {isLoadingUnassigned && <CircularProgress color="inherit" />}
    </div>
  );
};

export default Unassigned;
